import React from 'react';
import PropTypes from 'prop-types';

import './LoadingIndicator.less';

const LoadingIndicator = props => (
  <div {...props} className="LoadingIndicator">
    <span className="LoadingIndicator-dot" />
    <span className="LoadingIndicator-dot" />
    <span className="LoadingIndicator-dot" />
    <span className="LoadingIndicator-dot" />
    <span className="LoadingIndicator-dot" />
  </div>
);

export default LoadingIndicator;



// WEBPACK FOOTER //
// ./spa/Components/LoadingIndicator.jsx